import cc from 'classcat'
import React from 'react'
import styles from './Alert.css'

export interface AlertProps {
  type?: string
  message: string
  error: boolean
  onClose: () => void
}

const defaultProps = {
  type: 'info',
}

export const Alert: React.FunctionComponent<AlertProps> = ({ message, type, error, onClose }) => {
  const classNames = cc([
    styles.alert,
    {
      [styles.danger]: type === 'danger',
      [styles.info]: type === 'info',
    },
  ])

  if (error) {
    return (
      <div className={classNames}>
        <button
          type="button"
          className={styles.close}
          data-dismiss="alert"
          onClick={() => {
            onClose()
          }}
        >
          <span>&times;</span>
        </button>
        <div>{message}</div>
      </div>
    )
  } else {
    return null
  }
}

Alert.defaultProps = defaultProps
export default Alert
